import BaseResource from '@/app-core/lib/data/resource/BaseResource'

export default class CustomerInfoResource extends BaseResource {
  constructor(payload = {}) {
    super(payload)

    this.Id = payload.Id ?? null
    this.Firstname = payload.Firstname ?? ''
    this.Lastname = payload.Lastname ?? ''

    this.Phone = payload.Phone ?? ''
    this.PhonePrefix = payload.PhonePrefix ?? ''
    this.PhoneValidated = payload.PhoneValidated ?? false

    this.Phone2 = payload.Phone2 ?? ''
    this.Phone2Prefix = payload.Phone2Prefix ?? ''
    this.Phone2Validated = payload.Phone2Validated ?? false

    this.Phone3 = payload.Phone3 ?? ''
    this.Phone3Prefix = payload.Phone3Prefix ?? ''
    this.Phone3Validated = payload.Phone3Validated ?? false

    this.Email = payload.Email ?? ''
    this.EmailValidated = payload.EmailValidated ?? ''
    this.SocialProvider = payload.SocialProvider ?? ''
    this.Newsletter = payload.Newsletter ?? false
    this.Push = payload.Push ?? false
    this.SMS = payload.SMS ?? false
    this.NewsletterSystem = payload.NewsletterSystem ?? false
    this.SMSSystem = payload.SMSSystem ?? false
    this.PushSystem = payload.PushSystem ?? false
    this.Status = payload.Status ?? false
    this.DateAdded = payload.DateAdded ?? ''
  }

  /* PROPERTIES */
  get Fullname() {
    return `${this.Firstname}  ${this.Lastname}`
  }

  /* METHODS */
}
